import { InspectionSection } from './inspectionSection.model';
import { InspectionPoint } from './inspectionPoint.model';
import { InspectionPlugin } from './inspectionPlugin.model';
import { ISearch } from './ISearch.model';
import { IHost } from './IHost.model';
import { IInspectionVisitor } from './IInspectionVisitor.model';
import * as moment from 'moment';

import * as _ from 'lodash';
import { AppLabels } from '../../utils/appLabels.class';
import { InspectionSession } from './multi-edit.model';

export class Inspection implements ISearch, IHost {
  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    const statuses = this.searchByStatus(queryToLower);
    const progression = queryToLower.endsWith(' ')
      ? queryToLower.slice(0, -1)
      : queryToLower.endsWith(' %')
      ? queryToLower.slice(0, -2)
      : queryToLower;

    let search =
      (this.name != null && this.name.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.description != null && this.description.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.serial != null && this.serial.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.equipementType != null && this.equipementType.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.technicianName != null && this.technicianName.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.progression != null && this.progression.toString().indexOf(progression) !== -1) ||
      (this.startDate != null && moment(this.startDate).format('DD.MM.YYYY').indexOf(queryToLower) !== -1) ||
      (this.customerName != null && this.customerName.toLowerCase().indexOf(queryToLower) !== -1);
    if (window.location.href.includes('inspectionmanager')) {
      search =
        search ||
        (this.categories != null &&
          _.find(
            this.categories,
            (el: any) =>
              el.ProductLineId.toLowerCase().indexOf(queryToLower) !== -1 || el.CategoryId.toLowerCase().indexOf(queryToLower) !== -1
          ) !== undefined) ||
        (this.status != null && statuses.includes(this.status));
    }
    return search;
  }

  public sections: InspectionSection[] = [];
  public sectionsItems: any[] = [];
  public points: InspectionPoint[] = [];
  public plugins: InspectionPlugin[] = [];
  public allPlugins: InspectionPlugin[] = [];
  public sectionsById: any = {};
  public pointsById: any = {};
  public pluginsById: any = {};
  public foldersById: any = {};
  public insptectionInspectionCustomer: any;
  public duration: number;
  public isLoaded: boolean;
  events: any;
  public startDate: Date;
  parts: InspectionPlugin;
  public status: number;
  public coverImage: number;
  public categories: any[] = [];
  public tplName: string;
  public data: any;
  public inspectionType: number;
  public serial: string;
  public equipementType: string;
  public technicienId: string;
  public technician: any;
  public technicianName: string;
  public category: number;
  public customerName: string;
  public creator: string;
  public dateOfCreation: Date;
  public inputLanguage: string;
  public actionPlanId: string;
  public applicationType: number;
  public owner: string;
  public progression: number;
  public children: Inspection[];
  public parentId: string;
  public productLineId: string;
  public isOffline: boolean;
  public offlinePersonId: string;
  public offlineDate: Date;
  public endDate: Date;
  public updatedOffline: boolean;
  public deletedSections: string[];
  public deletedPoints: string[];
  public deletedFolders: string[];
  public deletedPlugins: string[];
  public assets: any[] = [];
  public syncObject: any;
  public isSent: boolean;
  public etag: Date;
  public lastSyncDate: Date;
  public isSynchronizing: boolean;
  public reportType: string;
  public applicationSubType?: number;
  public reportItemId: string;
  public isNew: boolean;
  public attachedTemplates?: string[];
  public currency: string;
  public hourlyRate?: number;
  public quotationNumber: string;
  public sessions: InspectionSession[];

  constructor(public id: string, public name: string, public description: string) {
    this.sectionsById = {};
    this.pointsById = {};
    this.pluginsById = {};
    this.foldersById = {};
  }

  public isTemplate(): boolean {
    return this.inspectionType === InspectionType.Template;
  }

  public accept(visitor: IInspectionVisitor): void {
    this.plugins?.forEach((plugin) => plugin.accept(visitor));
    this.sections?.forEach((section) => section.accept(visitor));
  }

  public getSerialNumber(): string {
    if (!this.data?.machine) return '';

    if (this.data.machine instanceof Array) {
      this.serial = this.data.machine
        .filter((m) => m.SerialNumber)
        .map((m) => m.SerialNumber)
        .join(', ');
      return this.serial;
    }

    if (this.data.machine.Serial instanceof Array) {
      this.serial = this.data.machine.Serial.filter((s) => s).join(', ');
      return this.serial;
    }

    this.serial = this.data.machine.Serial?.toString() || '';
    return this.serial;
  }

  public getEquipementType(): string {
    if (this.data != null && this.data.machine != null) {
      if (this.data.machine instanceof Array) {
        this.equipementType = this.data.machine.map((m) => m.name).join(', ');
        return this.data.machine.map((m) => m.name).join(', ');
      } else {
        this.equipementType = this.data.machine.name;
        return this.data.machine.name;
      }
    }
    this.equipementType = '';
    return '';
  }

  public getTechnicianId() {
    this.technicienId = this.data != null && this.data.contact != null ? this.data.contact.TechnicienId : null;
    return this.technicienId;
  }

  public getProductLineId() {
    this.productLineId = this.categories != null && this.categories[0] != null ? this.categories[0].ProductLineId : '';
    return this.productLineId;
  }

  public getReportType() {
    const inspectionInfoPlugin = this.allPlugins.find((p) => p.pluginType === 'inspectionInfo');
    if (inspectionInfoPlugin) {
      const types = [...AppLabels.MAINTENANCE_TYPES, ...AppLabels.OPTIMIZATION_TYPES];
      const type = types.find((t) => t.value === inspectionInfoPlugin.config.TypeInspection);
      if (type) {
        this.reportType = type.label;
        return type.label;
      }
    }
    return '';
  }

  // There are properties whose value comes from data.
  // Ex : equipementType value is computed from data.machine array
  // This method triggers computations of such values
  // Potential future bugs : this should be called each time data are changed to keep properties and data synced
  public setDataProperties() {
    this.getEquipementType();
    this.getProductLineId();
    this.getReportType();
    this.getSerialNumber();
    this.getTechnicianId();
  }

  searchByStatus(query: string) {
    const statuses = {
      new: 0,
      published: 100,
      scheduled: 150,
      'in progress': 200,
      done: 250,
      reviewed: 300,
      released: 350,
      cancelled: -100,
      deleted: -10,
      archived: -200
    };

    const values = [];

    const names = Object.getOwnPropertyNames(statuses);
    names.forEach((name) => {
      if (name.indexOf(query) !== -1) {
        values.push(statuses[name]);
      }
    });

    return values;
  }
}

enum InspectionType {
  Template = 200,
  Inspection = 100
}
